export const subMenuListFeatureTranslationJP = {
  SubMenuGroupListFeature: {
    Component: {
      csv_output: 'CSV出力',
      delete: '削除',
      close: '閉じる',
      setting: '設定',
      search: '絞り込み',
      reload: 'リロード',
      detail: '詳細',
      save: '保存',
    },
    Text: {
      submenugroup_name: 'サブメニューグループ名',
      kosenum: '構成数',
      check_duplicate_submenu_flg_title: 'サブメニュー重複チェック',
      list_of_submenu_groups: 'サブメニューグループ一覧',
      cd: 'コード',
      name: '名称',
      all: '全て',
      submenu_group_details: 'サブメニューグループ詳細',
      default_configuration: 'デフォルト設定：',
      submenu_name: 'サブメニュー名',
      setting_priority_order: '設定優先順',
      kalbi: 'カルビ',
      selection_condition: '選択条件',
      mandatory_selection: '必須選択',
      single_control: 'お1人様制御',
      single_control_mandatory: 'お1人様制御（必須選択）',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      traditional_chinese: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      display_name: '表示名',
      default_selection: 'デフォルト選択',
      sub_menu: 'Sメニュー',
      sub_title_menu: 'Sタイトル',
      guide1: '※モバイルオーダーの表示名は、',
      guide2: '日本語以外の言語を選択し、その言語が未設定の場合、',
      guide3: '英語が表示されます。',
    },
    Table: {
      selection: '選択',
      group_cd: 'コード',
      group_name: 'グループ名称',
      assigned_menu: '割り当てられているメニュー',
      remarks: '備考',
      selection_condition: '選択条件',
      mandatory_selection: '必須選択',
      single_control: 'お1人様制御',
      single_control_mandatory: 'お1人様制御（必須選択）',
      default_selection: 'デフォルト選択',
      menu_type: 'タイプ',
    },
  },
};
